import { useState } from "react";
import "./App.css";
import { AboutTab } from "./pages/Home";
import { GalleryTab } from "./pages/Gallery";
import { CodeTab } from "./pages/Code";
import homeicon from "./components/img/icons/home.png";
import galleryicon from "./components/img/icons/photos.png";
import codeicon from "./components/img/icons/code.png";

function App() {
  const [activeTab, setActiveTab] = useState("home");

  const navItems = [
    { id: "home", label: "Home", icon: homeicon },
    { id: "gallery", label: "Gallery", icon: galleryicon },
    { id: "code", label: "Code", icon: codeicon },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case "gallery":
        return <GalleryTab />;
      case "code":
        return <CodeTab />;
      case "home":
      default:
        return <AboutTab />;
    }
  };

  return (
    <div className="App">
      {/* Desktop Navigation - Top */}
      <nav className="navbar navbar-desktop">
        <div className="nav-container">
          <ul className="nav-menu">
            {navItems.map((item) => (
              <li key={item.id} className="nav-item">
                <button
                  className={`nav-link ${activeTab === item.id ? "active" : ""}`}
                  onClick={() => setActiveTab(item.id)}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </nav>

      {/* Main Content */}
      <main className="main-content">{renderContent()}</main>

      {/* Mobile Navigation - Bottom */}
      <nav className="navbar navbar-mobile">
        <ul className="nav-menu-mobile">
          {navItems.map((item) => (
            <li key={item.id} className="nav-item-mobile">
              <button
                className={`nav-link-mobile ${activeTab === item.id ? "active" : ""}`}
                onClick={() => {
                  setActiveTab(item.id);
                }}
              >
                <img
                  className="nav-icon"
                  src={item.icon}
                  alt={item.label}
                  width={25}
                />
                <span className="nav-label">{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </div>
  );
}

export default App;
